var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1460_12469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99167 0H5.00417C6.40764 1.67014 7.82361 3.32917 9.22709 4.99931C7.82361 6.66944 6.40417 8.32639 5.00556 10H4.99584C3.59167 8.32917 2.17431 6.67014 0.770142 4.99931C2.17153 3.32778 3.59167 1.67222 4.99167 0ZM1.59097 4.99931C2.71667 6.35278 3.85972 7.69306 4.99931 9.03472C6.1375 7.69167 7.28195 6.35278 8.40695 4.99931C7.28264 3.64514 6.1382 2.30625 4.99931 0.963889C3.85903 2.30556 2.71459 3.64514 1.59097 4.99931Z",
    fill: "#0C4284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59094 4.99931C2.71455 3.64515 3.859 2.30556 4.99928 0.963898C6.13816 2.30626 7.28261 3.64515 8.40691 4.99931C7.28191 6.35279 6.13747 7.69168 4.99928 9.03473C3.85969 7.69307 2.71664 6.35279 1.59094 4.99931Z",
    fill: "#01C1D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1460_12469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.a2edf93c7e14205d169d64f55eb80020.svg";
export { ForwardRef as ReactComponent };